// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

/* eslint-disable spire/export-styles */
import { ProductContext, ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import changeQtyOrdered from "@insite/client-framework/Store/Pages/ProductList/Handlers/ChangeQtyOrdered";
import changeUnitOfMeasure from "@insite/client-framework/Store/Pages/ProductList/Handlers/ChangeUnitOfMeasure";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import { CustomAppState } from "@pacific/App/Store/Reducers";
import React, { FC } from "react";
import { connect, ResolveThunks } from "react-redux";

interface OwnProps {
    product: ProductModel;
    idx?: number;
}

const mapStateToProps = (state: CustomAppState, ownProps: OwnProps) => ({
    productInfo: state.xProductList.productInfosByProductId[ownProps.product.id],
});

const mapDispatchToProps = {
    changeUnitOfMeasure,
    changeQtyOrdered,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & OwnProps;

const ProductListProductContext: FC<Props> = ({
    product,
    productInfo,
    children,
    changeUnitOfMeasure,
    changeQtyOrdered,
    idx,
}) => {
    if (!productInfo) {
        return null;
    }

    const productContext: ProductContextModel = {
        product,
        productInfo,
        idx,
        onQtyOrderedChanged: qtyOrdered => changeQtyOrdered({ productId: product.id, qtyOrdered }),
        onUnitOfMeasureChanged: unitOfMeasure => changeUnitOfMeasure({ productId: product.id, unitOfMeasure }),
    };

    return <ProductContext.Provider value={productContext}>{children}</ProductContext.Provider>;
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductListProductContext);
